<div class="bd_banner">

  <ng-container *ngIf="pageLoading == false">
    <owl-carousel-o [options]="carouselbannerslide">
      <ng-container *ngFor="let slide of sliders; let i = index">
        <ng-template carouselSlide [id]="slide._id">
          <div class="item">
            <img src="{{slide?.image_path}}" class="w-100 banner-slide">
          </div>
          <div class="banner_text " *ngIf="i==0">
            <div class="container">
              <div class="banner_text_box">
                <!-- <h2>Please Do Not Login As<br>We Use This Site For Testing And QA Purpose</h2> -->
                <h2>{{environment.BANNER_TEXT}}</h2>
                <h3>
                  <!-- <span>Fetching a fair price</span>  -->
                  <!-- <app-typewriter [texts]="['Fetching a fair price', 'at the lowest cost.']" [period]="200"></app-typewriter> -->

                </h3>

                <!-- <ng-container *ngIf="authService.userLoggedIn()">
                            <a routerLink="/dashboard" class="bd_btn green_btn">Dashboard</a>
                        </ng-container>
                        <ng-container *ngIf="!authService.userLoggedIn()">
                            <a routerLink="/register" class="bd_btn green_btn">Sign Up</a>
                        </ng-container> -->
              </div>

              <!-- <div class="overdiv-main">

                <video width="100%" height="100%" autoplay muted>
                  <source src="assets/img/Login-Tea-InnTech.mp4" type="video/mp4">
                  <source src="assets/img/Login-Tea-InnTech.ogg" type="video/ogg">
                  Your browser does not support the video tag.
                </video>

                <img src="assets/img/banner-top.jpg" class="w-100" alt="banner">
              </div>-->

            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </ng-container>

  <ng-container *ngIf="pageLoading == true">
    <div class="row">
      <div class="col-md-12">
        <ngx-skeleton-loader appearance="" [theme]="{
                    'height': '630px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                }"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>


</div>

<div class="ptb d-none">
  <div class="container">
    <ng-container *ngIf="pageLoading == false">
      <owl-carousel-o [options]="carouselOptions">
        <ng-container *ngFor="let slide of sliders; let i = index">
          <ng-template carouselSlide [id]="slide._id">
            <div class="item">
              <div class="row align-items-center">
                <div class="col-md-5">
                  <div class="step_text">
                    <!-- <h5>{{ i + 1 }}</h5>
                    <h2>{{ slide.title }} </h2>
                    <p>{{ slide.description }}</p> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="step_img">
                    <img [src]="slide.image_path">
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-container>

    <ng-container *ngIf="pageLoading == true">
      <div class="row">
        <div class="col-md-3" *ngFor="let item of [1,1,1,1]">
          <ngx-skeleton-loader appearance="" [theme]="{
                        'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                    }"></ngx-skeleton-loader>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="our-servicemain" *ngIf="services.length > 0 || service_content?.content">
  <div class="container">
    <div class="section-title text-center mb-4">
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="inner-style" data-aos="fade-up">
            <h2 class="h-style">Our <span>Services</span></h2>
          </div>
          <div [innerHtml]="service_content?.content"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" *ngFor="let service of services; let i = index" data-aos="fade-up">
        <div class="service-box">
          <figure class="shine-overlay">
            <img src="{{service?.image_path}}" class="w-100">
            <div class="shine"></div>
          </figure>
          <div class="service-content">
            <h3>{{service?.title}}</h3>
            <p>{{service?.description}}</p>
            <a routerLink="/services/{{service?.slug}}">Read more</a>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

<div class="whytea d-none">
  <div class="container">
    <div class="section-title text-center mb-4">
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="inner-style">
            <h2 class="h-style">Why <span>Tea Inntech</span></h2>
          </div>
          <div>Achieving a fair price discovery at the lowest cost in terms of resources and overheads at the fastest
            turnaround time was never this easy</div>
        </div>
      </div>
    </div>
    <div class="teacon">
      <ul>
        <li>
          <h3>First movers and pioneers</h3>
          <p>Tea Inntech is India’s first to introduce the concept of Ex-garden sales that facilitates sales between
            suppliers and buyer’s directly. Leading the way today while setting standards for tomorrow. Pioneering
            innovation today – Shaping the industry of tomorrow. </p>
          <span class="senum">N</span>
        </li>
        <li>
          <h3>Lowest cost of sales and procurement</h3>
          <p>Cost of sales and procurement on Tea Inntech is the lowest as compared to other platforms in terms of
            resources and overheads.</p>
          <span class="senum">B</span>
        </li>
        <li>
          <div>
            <h3>Fair Price discovery</h3>
            <p>Explore from the widest range of buyers and sellers on India’s First B2B trade platform</p>
          </div>
          <span class="senum">P</span>
        </li>
        <li>
          <div>
            <h3>Fastest turnaround time</h3>
            <p>It is our responsibility to ship the teas from the garden to the buyer’s warehouse at the fastest
              possible time</p>
          </div>
          <span class="senum">C</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="warow">
    <img src="./assets/img/whyarrow.png" alt="">
  </div>
</div>

<div class="whychoosetee" *ngIf="why_choose_us?.length">
  <div class="container">
    <div class="chooseteemain" data-aos="fade-up">
      <div class="section-title text-center mb-4">
        <div class="inner-style">
          <h2 class="h-style">Why <span>Tea Inntech</span></h2>
        </div>
      </div>
      <ng-container *ngIf="pageLoading == false">
        <div class="row no-gutters" *ngIf="why_choose_us?.length; else noWhyChooseUs" data-aos="fade-up">
          <div class="col-md-3 whychoosebox" *ngFor="let item of why_choose_us">
            <figure>
              <img [src]="item?.image_path" class="w-100">
            </figure>
            <h3>{{item?.title}}</h3>
            <p>{{item?.description}}</p>
          </div>
        </div>
        <ng-template #noWhyChooseUs>
          <p>NO DATA FOUNDS</p>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="pageLoading == true">
        <div class="row">
          <div class="col-md-3" *ngFor="let item of [1,1,1,1]">
            <ngx-skeleton-loader appearance="" [theme]="{
                            'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                        }"></ngx-skeleton-loader>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="how-it-work">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 pr-5" data-aos="fade-up">
        <div class="section-title">
          <div class="inner-style">
            <h2 class="h-style">How It <span>Works</span></h2>
          </div>
          <ng-container *ngIf="pageLoading == false">
            <div [innerHtml]="how_it_works?.content"></div>
          </ng-container>

        </div>

      </div>
      <div class="col-md-6" *ngIf="how_it_works?.image_path" data-aos="fade-up">
        <figure class="mb-0 how-img position-relative shine-overlay">
          <img [src]="how_it_works?.image_path" class="w-100 ">
          <div class="shine"></div>
        </figure>
      </div>
      <ng-container *ngIf="pageLoading == true">
        <div class="col-md-12">
          <ngx-skeleton-loader appearance="" [theme]="{
                    'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                }"></ngx-skeleton-loader>
        </div>
      </ng-container>

    </div>
  </div>
</div>


<div class="our-associations" *ngIf="organisational_associate_content?.content || organisational_associates">
  <div class="container">
    <div class="d-flex mb-4 justify-content-center">
      <div class="section-title">
        <div class="inner-style" data-aos="fade-up">
          <h2 class="h-style">Our <span>Support</span></h2>
        </div>
        <div [innerHtml]="organisational_associate_content?.content"></div>
      </div>
      <!-- <div class="ml-auto">
                <a routerLink="associates" class="btn greenbutton">Read More</a>
            </div> -->
    </div>

    <ng-container *ngIf="pageLoading == false">
      <owl-carousel-o [options]="carouselOptions2">
        <ng-container *ngFor="let association of organisational_associates; let i = index">
          <ng-template carouselSlide [id]="association._id">
            <div class="item">
              <div class="associations-box">
                <!-- <img [src]="slide.image_path"> -->
                <img [src]="association?.logo_path" class="w-100">
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-container>

    <ng-container *ngIf="pageLoading == true">
      <div class="row">
        <div class="col-md-3" *ngFor="let item of [1,1,1,1]">
          <ngx-skeleton-loader appearance="" [theme]="{
                        'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                    }"></ngx-skeleton-loader>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="our-associations" *ngIf="associations_content || associations">
  <div class="container">
    <div class="d-flex mb-4 justify-content-center">
      <div class="section-title">
        <div class="inner-style" data-aos="fade-up">
          <h2 class="h-style">Our <span>Associations</span></h2>
        </div>
        <div [innerHtml]="associations_content"></div>
      </div>
      <!-- <div class="ml-auto">
                <a routerLink="associates" class="btn greenbutton">Read More</a>
            </div> -->
    </div>


    <ng-container *ngIf="pageLoading == false">

      <owl-carousel-o [options]="carouselOptions2">
        <ng-container *ngFor="let association of associations; let i = index">
          <ng-template carouselSlide [id]="association._id">
            <div class="item">
              <div class="associations-box">
                <!-- <img [src]="slide.image_path"> -->
                <img [src]="association?.logo_path" class="w-100">
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-container>

    <ng-container *ngIf="pageLoading == true">
      <div class="row">
        <div class="col-md-3" *ngFor="let item of [1,1,1,1]">
          <ngx-skeleton-loader appearance="" [theme]="{
                        'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                    }"></ngx-skeleton-loader>
        </div>
      </div>
    </ng-container>

    <!-- <div class="pt-4 mt-3">
            <img class="w-100 rounded" src="assets/img/electronic.png">
        </div> -->
  </div>
</div>

<div class="news-main" *ngIf="blogs.length>0">
  <div class="container">
    <div class="section-title mb-4">
      <div class="inner-style" data-aos="fade-up">
        <h2 class="h-style">Our Latest <span>News</span></h2>
      </div>
    </div>
    <div class="position-relative">
      <ng-container *ngIf="pageLoading == false">
        <div class="blog-row">

          <div class="blog-tambel wow fadeInLeft" *ngFor="let blog of blogs" data-wow-delay="0.5s"
            data-wow-duration="1s">
            <div class="blog-img shine-overlay">
              <img [src]="blog?.image_path" alt="">
              <div class="shine"></div>
            </div>
            <div class="blog-content">
              <h2>{{blog?.created_at | date}}</h2>
              <p>{{blog?.description}}</p>
              <a class="redmore" [href]="blog?.slug" target="_blank">Read More</a>
            </div>
          </div>
        </div>

      </ng-container>
      <ng-container *ngIf="pageLoading == true">
        <div class="row">
          <div class="col-md-6">
            <ngx-skeleton-loader appearance="" [theme]="{
                            'height': '515px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                        }"></ngx-skeleton-loader>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6" *ngFor="let item of [1,1,1,1]">
                <ngx-skeleton-loader appearance="" [theme]="{
                                        'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                                    }"></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<div class="highlights-main" *ngIf="highlights?.content || highlights?.image_path || highlights?.content">
  <div class="container">
    <div class="inner-style" data-aos="fade-up">
      <h2 class="h-style">Highlights <span>Tea Inntech</span> Journey </h2>
    </div>
    <div class="row align-items-center">
      <div class="col-md-7 pr-5">
        <div class="section-title">
          <div [innerHtml]="highlights?.content"></div>
        </div>
      </div>
      <div class="col-md-5" *ngIf="highlights?.image_path">
        <figure class="mb-0 shine-overlay">
          <img [src]="highlights?.image_path" class="w-100">
          <div class="shine"></div>
        </figure>
      </div>
      <ng-container *ngIf="pageLoading == true">
        <div class="col-md-12">
          <ngx-skeleton-loader appearance="" [theme]="{
                    'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                }"></ngx-skeleton-loader>
        </div>
      </ng-container>
    </div>
    <div class="row align-items-center cTop">
      <div class="col-lg-5" *ngIf="highlights?.image_path">
        <figure class="mb-0 shine-overlay">
          <img [src]="highlights?.image_path" class="w-100">
          <div class="shine"></div>
        </figure>
      </div>
      <div class="col-md-7">
        <div class="section-title">
          <ng-container *ngIf="pageLoading == false">
            <div [innerHtml]="highlights?.content"></div>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
  <div class="getstarted" data-aos="fade-up">
    <div class="container">
      <div class="getstarted-box">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <h3>Let’s chat ?</h3>
            <ng-container *ngIf="pageLoading == false">
              <div [innerHTML]="ready_to_get_started?.content"></div>
              <div class="mt-4">
                <a class="start-btn btn" routerLink="contact-us">Start Now</a>
              </div>
            </ng-container>
            <ng-container *ngIf="pageLoading == true">
              <ngx-skeleton-loader appearance="" [theme]="{
                                'height': '250px', 'width': '100%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                            }"></ngx-skeleton-loader>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="about_sec d-none">

  <div class="container-fluid">
    <ng-container *ngIf="pageLoading == false">
      <div class="row no-gutters align-items-center" *ngIf="pageContent">
        <div class="col-md-5" *ngIf="pageContent?.image_path">
          <div class="about_img">
            <img src="{{ pageContent?.image_path }}" class="img-fluid">
          </div>
        </div>
        <div [ngClass]="{'col-md-12': !pageContent?.image_path, 'col-md-7': pageContent?.image_path}">
          <div class="about_text" [innerHTML]="pageContent?.content ?? null"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="pageLoading == true">
      <div class="row m-0">
        <div class="col-md-5 text-center">
          <ngx-skeleton-loader appearance="" [theme]="{
                        'height': '250px', 'width': '50%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '5px'
                    }"></ngx-skeleton-loader>
        </div>
        <div class="col-md-7">
          <div class="about_text">
            <ngx-skeleton-loader appearance="" [theme]="{
                            'height': '25px', 'width': '50%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '0px'
                        }"></ngx-skeleton-loader><br>

            <ng-container *ngFor="let item of [1,1,1,1]">
              <ngx-skeleton-loader appearance="" [theme]="{
                                'height': '10px', 'width': '80%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '0px'
                            }"></ngx-skeleton-loader><br>
            </ng-container><br>

            <ng-container *ngFor="let item of [1,1,1]">
              <ngx-skeleton-loader appearance="" [theme]="{
                                'height': '10px', 'width': '80%', 'background-color': 'rgb(116 167 147 / 40%)', 'border-radius': '0px'
                            }"></ngx-skeleton-loader><br>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>



</div>

<div class="ptb subscribe_sec d-none">
  <div class="container">
    <div class="bd_subscribe">
      <h2>Subscribe to our newsletter and stay updated</h2>

      <!-- <div class="subscribe_form">
                <form [formGroup]="newsletterForm">
                    <div class="form_group">
                        <input type="text" formControlName="name" placeholder="Name" [class.is-invalid]="( !Global.isInputValid(newsletterForm, 'name') )">
                    </div>
                    <div class="form_group">
                        <input type="email" formControlName="email" placeholder="Email ID" [class.is-invalid]="( !Global.isInputValid(newsletterForm, 'email') )">
                    </div>
                    <button type="submit" class="btn" [disabled]="!newsletterForm.valid" (click)="submit($event)">
                        <span class="indicator-label">Subscribe</span>
                        <span class="indicator-progress">Please wait...
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                </form>
            </div> -->

      <div class="bd_social">
        <ng-container *ngIf="pageLoading == false">
          <a *ngFor="let item of this.socialLinks" target="_blank" href="{{item?.link}}">
            <img src="{{item?.icon_path}}" alt="" style="width: 100%;">
          </a>
        </ng-container>
        <ng-container *ngIf="pageLoading == true">
          <a *ngFor="let item of [1,1,1,1,1,1]">
            <ngx-skeleton-loader appearance="" [theme]="{
                            'height': '100%', 'width': '100%', 'background-color': '#e3ca93', 'border-radius': '100%', 'margin': '0'
                        }"></ngx-skeleton-loader>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
